import { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import { Text, Float, MeshReflectorMaterial, Sparkles, Image } from '@react-three/drei';
import * as THREE from 'three';
import { useExperienceStore } from '../state/useExperienceStore';

export const GymScene = () => {
  const { mode } = useExperienceStore();
  const groupRef = useRef<THREE.Group>(null!);

  const athleticBackImage = "https://images.unsplash.com/photo-1541534741688-6078c6bfb5c5?q=80&w=2000&auto=format&fit=crop";

  useFrame((state) => {
    if (mode !== 'GYM') return;
    const time = state.clock.getElapsedTime();
    groupRef.current.rotation.y = Math.sin(time * 0.1) * 0.05;
  });

  if (mode !== 'GYM') return null;

  return (
    <group ref={groupRef} position={[0, 0, 0]}>
      <fog attach="fog" args={['#050505', 10, 50]} />
      
      {/* Dynamic Background Elements */}
      <Sparkles count={200} scale={[40, 20, 40]} size={2} speed={0.5} opacity={0.2} color="#06b6d4" />
      
      {/* Athletic Back "GPSA" Visual Backdrop */}
      <Float speed={1.5} rotationIntensity={0.2} floatIntensity={0.5}>
        <group position={[0, 5, -25]}>
          <Image 
            url={athleticBackImage} 
            transparent 
            opacity={0.15} 
            scale={[30, 40]} 
            grayscale={1}
          />
          <mesh position={[0, 0, -0.1]}>
             <planeGeometry args={[32, 42]} />
             <meshBasicMaterial color="#06b6d4" transparent opacity={0.05} wireframe />
          </mesh>
        </group>
      </Float>
      
      {/* Gym Floor */}
      <mesh position={[0, -5, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[100, 100]} />
        <MeshReflectorMaterial
          blur={[300, 100]}
          resolution={512}
          mixBlur={1}
          mixStrength={10}
          roughness={1}
          depthScale={1.2}
          minDepthThreshold={0.4}
          maxDepthThreshold={1.4}
          color="#0a0a0a"
          metalness={0.5}
        />
      </mesh>

      {/* Futuristic Columns */}
      {[-20, 20].map((x) => (
        [-20, 0, 20].map((z) => (
          <mesh key={`${x}-${z}`} position={[x, 5, z]}>
            <cylinderGeometry args={[0.5, 0.5, 20, 32]} />
            <meshStandardMaterial color="#222" metalness={0.9} roughness={0.1} />
            <mesh position={[0, 0, 0]}>
               <cylinderGeometry args={[0.55, 0.55, 20.1, 32]} />
               <meshBasicMaterial color="#06b6d4" transparent opacity={0.1} wireframe />
            </mesh>
          </mesh>
        ))
      ))}

      {/* Floating UI Support or decoration */}
      <Float speed={2} rotationIntensity={0.5} floatIntensity={0.5}>
        <Text
          position={[0, 12, -15]}
          fontSize={3}
          color="#06b6d4"
          font="https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hjp-Ek-_EeA.woff"
          fontWeight="black"
          letterSpacing={0.2}
          textAlign="center"
        >
          Bienvenido
        </Text>
        <Text
          position={[0, 10, -15]}
          fontSize={0.8}
          color="white"
          fillOpacity={0.4}
          fontWeight="medium"
          letterSpacing={0.5}
          textAlign="center"
        >
          SELECCIONA UN GRUPO MUSCULAR PARA COMENZAR
        </Text>
      </Float>

      {/* Central Platform */}
      <mesh position={[0, -4.9, 0]} rotation={[-Math.PI / 2, 0, 0]}>
        <ringGeometry args={[8, 8.2, 64]} />
        <meshBasicMaterial color="#06b6d4" transparent opacity={0.5} />
      </mesh>
      
      <pointLight position={[0, 10, 0]} intensity={2} color="#06b6d4" />
      <ambientLight intensity={0.2} />
    </group>
  );
};
